import { NgModule } from '@angular/core';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { CommonModule } from '@angular/common';
import { PaymentOtdComponent } from './components/payment-otd/payment-otd.component';
import { PaymentOtdBtnComponent } from './components/payment-otd-btn/payment-otd-btn.component';
import { PaymentModule } from '../payment/payment.module';
import { PaymentSipSlabsModule } from '../payment-sip-slabs/payment-sip-slabs.module';
import { PaymentSipButtonModule } from '../payment-sip-button/payment-sip-button.module';
import { ModuleLoaderModule } from '../module-loader/module-loader.module';
import { PlaceholderLoaderModule } from '../placeholder-loader/placeholder-loader.module';
import { PaymentSipUpiTimerModule } from '../payment-sip-upi-timer/payment-sip-upi-timer.module';
import { CaptchaInputModule } from '../captcha-input/captcha-input.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { TipcardInfoModule } from '../tipcard-info/tipcard-info.module';



@NgModule({
  declarations: [
    PaymentOtdComponent,
    PaymentOtdBtnComponent
  ],
  exports: [
    PaymentOtdComponent,
    PaymentOtdBtnComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    PaymentModule,
    MatBottomSheetModule,
    MatButtonModule,
    PaymentSipSlabsModule,
    PaymentSipButtonModule,
    ModuleLoaderModule,
    MatRippleModule,
    PlaceholderLoaderModule,
    PaymentSipUpiTimerModule,
    CaptchaInputModule,
    ReactiveFormsModule,
    TipcardInfoModule
  ]
})
export class PaymentOtdModule { }
